import {createContext} from 'react';

const CollectionsContext = createContext({
  selected: {},
  setSelected: () => {}
});

export default CollectionsContext;
